/*
 *  *
 *  *  * Copyright (c) 2023 Hg Digital, Acrox Bank
 *  *  *************************************************************
 *  *  *Projeto  : acrox-calculator
 *  *  *Autor    : diegobrock
 *  *  *Data     : 21/06/2023 22:25
 *  *  *Empresa  : HG digital/Acrox Bank
 *  *  *************************************************************
 *  *
 */

// tslint:disable:variable-name
export class AccessTokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;


  constructor() {
    this.access_token = '';
    this.refresh_token = '';
    this.token_type = '';
    this.expires_in = 0;
  }
}
